import { useEffect, useRef, useState } from 'react';
import {useTranslation} from 'react-i18next';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faQuestion } from '@fortawesome/free-solid-svg-icons';

import { LANGUAGES } from '../../App';
import useAnalyticsEventTracker from '../../hooks/use-analytics';

const LanguageDropdown = ({
  position,
  defaultValue = '',
  onClickHandler = () => {},
  name,
  allowGA = false,
  allowClear = false,
  placeholderText,
  onlyShowNative = false
}) => {
  const {t: translate } = useTranslation();
  placeholderText = placeholderText ? placeholderText : translate('select-language');
  const [dropdownActive, setDropdownActive] = useState(false);
  const enabledLangs = LANGUAGES.filter((lang) => lang.enabled === true)
  const dropdownLangs = onlyShowNative === true ? enabledLangs.filter((lang) => lang.native === true) : enabledLangs;

  //Need to check default exists in our lang list before setting it
  const defaultCheck = () => {
    let matchedLang = dropdownLangs.filter(lang => lang.name === defaultValue.toLowerCase());

    if( matchedLang.length > 0 ) {
      return matchedLang[0].name;
    } else {
      return placeholderText; 
    }
  }
  const [activeOption, setActiveOption] = useState(defaultCheck());
  const [hoveredOption, setHoveredOption] = useState(null);
  const dropdownPosition = position || 'bottom';
  const langDropdown = useRef();
  const langDropdownOptions = useRef();
  const gaEventTracker = useAnalyticsEventTracker('Registration');

  const dropdownClass =
    dropdownActive === true
      ? `dropdown ${dropdownPosition} dropdown--active`
      : `dropdown ${dropdownPosition}`;

  const flagHandler = (lang) => {
    setActiveOption(lang);
    setDropdownActive(false);
    onClickHandler(name, lang);
    if(allowGA) {
      gaEventTracker(`${name}-clicked`, lang);
    }
  };

  document.addEventListener('click', function (e) {
    e.stopPropagation();
    let target = e.target;
    if (target !== langDropdown.current) {
      setDropdownActive(false);
    }
  });

  const handleKeyDown = (e) => {
    //38 = arrow up
    //40 = arrow down
    //13 = enter
    if( e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 13 ) {
      e.preventDefault();
      e.stopPropagation();
    }

    if( e.keyCode === 40 ) {
      setDropdownActive(true);
    }

    if( e.keyCode === 13 ) {
      if( langDropdown.current ) {
        let selectedOption = langDropdown.current.querySelector(`[data-li="${hoveredOption}"]`);

        if( selectedOption ) {
          let selectedLang = selectedOption.getAttribute('data-lang');
          if( selectedLang ) {
            flagHandler(selectedLang)
          }
        }
      }
    }
  }

  const handleKeyNavigation = (e) => {
    // console.log(e.keyCode)
    //Keydown
    if( e.keyCode === 40 ) {
      if( hoveredOption !== null ) {
        let updatedIndex = hoveredOption + 1;

        if( updatedIndex > dropdownLangs.length - 1 ) {
          //stop on last entry
        } else {
          setHoveredOption(hoveredOption + 1)
        }
      } else {
        setHoveredOption(0) 
      }
    }
    
    //Keyup
    if( e.keyCode === 38 ) {
      if( hoveredOption !== null ) {
        let updatedIndex = hoveredOption - 1;
        if( updatedIndex < 0 ) {
          //stop on first entry
        } else {
          setHoveredOption(hoveredOption - 1)
        }
      } else {
        setHoveredOption(dropdownLangs.length - 1) 
      }
    }
  }

  const handleMouseOver = (e) => {
    if( e.target.getAttribute('data-li') ) {
      setHoveredOption(parseInt(e.target.getAttribute('data-li')));
    }
  }

  const handleBlur = (e) => {
    if( e.target !== langDropdown.current ) {
      setDropdownActive(false)
    }
  }

  useEffect(() => {
    if( dropdownActive === true ) {
      langDropdownOptions.current.focus()
    } else {
      setHoveredOption(null)
    }
  },[dropdownActive]);
  
  return (
    <div
      name={name}
      className="language-dropdown"
      onClick={() => setDropdownActive(!dropdownActive)}
      onKeyDown={(e) => handleKeyDown(e)}
      ref={langDropdown}
      tabIndex={0}
      onBlur={(e) => {handleBlur(e)}}
    >
      <div className="dropdown-choice">
        {activeOption !== placeholderText && <img src={`/flags/${activeOption.toLowerCase()}.png`} alt={activeOption} className="flag" />}{translate(activeOption)}
      </div>
      <div className={dropdownClass} onKeyDown={(e) => {handleKeyNavigation(e)}} ref={langDropdownOptions} tabIndex={0}>
        { allowClear && 
          <div 
            className='dropdown-option' 
            onClick={() => {flagHandler(placeholderText)}}
            onMouseOver={(e) => {handleMouseOver(e)}}
            onMouseOut={() => {setHoveredOption(null)}}
          >
            {placeholderText}
          </div>
        }
        { ! allowClear && <div className='dropdown-option dropdown-option--disabled'>{placeholderText}</div>}
        {dropdownLangs.map((lang, index) => {
          let flag = `/flags/${lang.name}.png`;
          let optionClass =
            activeOption === lang.name
              ? 'dropdown-option dropdown-option--active'
              : 'dropdown-option';
          
          if( hoveredOption === index ) {
            optionClass = 'dropdown-option hovered';
          }

          return (
            <div
              onClick={(e) => {flagHandler(e.target.getAttribute('data-lang'))}}
              className={optionClass}
              key={index}
              data-lang={lang.name}
              data-li={index}
              onMouseOver={(e) => {handleMouseOver(e)}}
              onMouseOut={() => {setHoveredOption(null)}}
            >
              <img src={flag} alt={lang.name} className="flag" />
              <span>{translate(lang.name)}</span>
            </div>
          );
        })}
        {/* <div
          onClick={flagHandler}
          className={activeOption === 'other' ? 'dropdown-option dropdown-option--active' : 'dropdown-option'}
          data-lang={'other'}
        >
          <FontAwesomeIcon icon={faQuestion} size="1x" className='flag'/>
          <span>Request Language</span>
        </div> */}
      </div>
    </div>
  );
};

export default LanguageDropdown;
